var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/employee-disclaimer-policy.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <div class=\"c-employee__disclaimer-outer\">\n\n            <p class=\"c-employee__title\">\n                ";
output += runtime.suppressValue((lineno = 7, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-employee-disclaimer-title",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n            </p>\n            <p class=\"c-employee__details\">\n                ";
output += runtime.suppressValue((lineno = 10, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-employee-disclaimer",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n            </p>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/employee-disclaimer-policy.j2"] , dependencies)